const React = require("react");
const h = React.createElement;

// Stepper numéroté du CJSyncModal. Une étape n'est cliquable que si elle est
// déjà atteinte (index <= maxUnlockedStep) -- on ne peut jamais sauter en
// avant vers une étape pas encore validée, seulement revenir en arrière.
const CJSyncStepper = ({ steps, activeStep, maxUnlockedStep, onSelect }) => h("div", { className: "cjwiz-stepper" },
  ...steps.map((step, index) => {
    const state = index === activeStep ? "active" : index < activeStep ? "done" : "upcoming";
    const clickable = index <= maxUnlockedStep;
    return h(React.Fragment, { key: step.id },
      h("button", {
        type: "button",
        className: `cjwiz-step-pill cjwiz-step-pill--${state}`,
        disabled: !clickable,
        onClick: () => clickable && onSelect(index),
      },
        h("span", { className: "cjwiz-step-pill__number" }, state === "done" ? "✓" : index + 1),
        h("span", { className: "cjwiz-step-pill__label" }, step.label)
      ),
      index < steps.length - 1 ? h("span", { className: `cjwiz-step-connector${index < activeStep ? " cjwiz-step-connector--done" : ""}` }) : null
    );
  })
);

module.exports = { CJSyncStepper };
